const departmentOverview = {
    AAAS: { name: "Afr & AfrAmerican Studies", courses: 190 },
    ANTH: { name: "Anthropology", courses: 151 },
    ARAB: { name: "Arabic", courses: 47 },
    ARTH: { name: "Art History", courses: 202 },
    ASCL: { name: "Asian Soc,Cultures&Lang", courses: 140 },
    ASTR: { name: "Astronomy", courses: 21 },
    BIOL: { name: "Biology", courses: 147 },
    CHEM: { name: "Chemistry", courses: 94 },
    CHIN: { name: "Chinese", courses: 42 },
    CLST: { name: "Classical Studies", courses: 73 },
    COCO: { name: "College Course", courses: 34 },
    COGS: { name: "Cognitive Science", courses: 29 },
    COLT: { name: "Comparative Literature", courses: 187 },
    COSC: { name: "Computer Science", courses: 205 },
    CRWT: { name: "Creative Writing", courses: 31 },
    CSDA: { name: "Digital Arts", courses: 8 },
    EARS: { name: "Earth Sciences", courses: 112 },
    ECON: { name: "Economics", courses: 58 },
    EDUC: { name: "Education", courses: 43 },
    EEER: { name: "East European, Eurasian & Russ", courses: 7 },
    ENGL: { name: "English", courses: 281 },
    ENGS: { name: "Engineering Sciences", courses: 173 },
    ENVS: { name: "Environmental Studies", courses: 69 },
    FILM: { name: "Film Studies", courses: 137 },
    FREN: { name: "French", courses: 98 },
    FRIT: { name: "French/Italian in Translation", courses: 18 },
    FYS: { name: "First-Year Seminar", courses: 0 },
    GEOG: { name: "Geography", courses: 142 },
    GERM: { name: "German", courses: 89 },
    GOVT: { name: "Government", courses: 295 },
    GRK: { name: "Greek", courses: 24 },
    HEBR: { name: "Hebrew", courses: 18 },
    HIST: { name: "History", courses: 258 },
    HUM: { name: "Humanities", courses: 11 },
    INTS: { name: "International Studies", courses: 22 },
    ITAL: { name: "Italian", courses: 35 },
    JAPN: { name: "Japanese", courses: 26 },
    JWST: { name: "Jewish Studies", courses: 99 },
    KOR: { name: "Korean", courses: 1 },
    LACS: { name: "Latin Am/Caribbean Studies", courses: 95 },
    LAT: { name: "Latin", courses: 38 },
    LATS: { name: "Latino Studies", courses: 26 },
    LING: { name: "Linguistics", courses: 59 },
    MATH: { name: "Mathematics", courses: 112 },
    MES: { name: "Middle Eastern Studies", courses: 86 },
    MUS: { name: "Music", courses: 248 },
    NAIS: { name: "Native Amer&Indigenous Studies", courses: 25 },
    PBPL: { name: "Public Policy", courses: 46 },
    PHIL: { name: "Philosophy", courses: 153 },
    PHYS: { name: "Physics", courses: 85 },
    PORT: { name: "Portuguese", courses: 34 },
    PSYC: { name: "Psychological & Brain Sciences", courses: 172 },
    QSS: { name: "Quantitative Social Science", courses: 37 },
    REL: { name: "Religion", courses: 209 },
    RUSS: { name: "Russian", courses: 63 },
    SART: { name: "Studio Art", courses: 46 },
    SOCY: { name: "Sociology", courses: 99 },
    SPAN: { name: "Spanish", courses: 145 },
    SPEE: { name: "Speech", courses: 17 },
    THEA: { name: "Theater", courses: 74 },
    TUCK: { name: "Tuck", courses: 3 },
    UKRA: { name: "Ukrainian", courses: 1 },
    WGSS: { name: "Women's, Gender, and Sexuality", courses: 165 },
    WRIT: { name: "Writing Program", courses: 54 }
};

export default departmentOverview;